export const selectItemSelected = state => state.transaction.itemTable
export const selectConfigTransactionTable = state => state.transaction.generalConfig
export const selectTransactionUuIdFlag = state => state.transaction.uuIdFlag
export const selectTransactionFlag = state => state.transaction.flagResponse
